<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/grounds/ranges/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('samples.range_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="50%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card" v-if="rowData">
              <div class="card-body" v-if="rowData">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.date') }}:</strong>
                        </h6>
                        {{ rowData.date }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('samples.nutrient') }}:</strong>
                        </h6>
                        <span v-if="rowData.ground_nutrient">{{
                          rowData.ground_nutrient.symbol
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('samples.range_name') }}:</strong>
                        </h6>
                        <span v-if="rowData.range_detail">{{
                          rowData.range_detail.name
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.limit_lower') }}:</strong>
                        </h6>
                        <span v-if="rowData.range_detail">{{
                          rowData.range_detail.lim_inf
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.limit_lower_operator')
                            }}:</strong
                          >
                        </h6>
                        <span v-if="rowData.range_detail">{{
                          rowData.range_detail.operator_lim_inf
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('common_words.limit_upper') }}:</strong>
                        </h6>
                        <span v-if="rowData.range_detail">{{
                          rowData.range_detail.lim_sup
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{
                              $t('common_words.limit_upper_operator')
                            }}:</strong
                          >
                        </h6>
                        <span v-if="rowData.range_detail">{{
                          rowData.range_detail.operator_lim_sup
                        }}</span>
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong
                            >{{ $t('common_words.recommendation') }}:</strong
                          >
                        </h6>
                        <span v-if="rowData.range_detail">{{
                          rowData.range_detail.recommendation
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at" v-if="rowData">
                <p class="text-muted">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              style="width: 100%"
              :data="queriedData"
              :border="true"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :fixed="column.fixed"
                :sortable="column.sortable"
                :align="column.align"
                :resizable="false"
              ></el-table-column>
              <el-table-column
                :min-width="150"
                :label="$t('common_words.operations')"
                fixed="right"
                :resizable="false"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route: 'grounds/ranges/pdf',
                  name_file: 'rangos_suelos.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route: 'grounds/ranges/excel',
                  name_file: 'rangos_suelos.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mt-4" v-if="viewDetails">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-12 text-center">
            <h6 class="text-muted">
              {{ $t('samples.ground_range_info') }}
              {{ rangeGroundForm.ground_nutrient.symbol }} |
              {{ rangeGroundForm.date }}
            </h6>
          </div>
        </div>
        <br />
        <div v-if="isIndex()">
          <div class="col-sm-12">
            <el-table
              stripe
              style="width: 100%"
              :data="tableViewData"
              :border="true"
            >
              <el-table-column
                min-width="150"
                prop="name"
                :label="$t('samples.range_name')"
              ></el-table-column>
              <el-table-column
                min-width="100"
                prop="operator_lim_inf"
                :label="$t('common_words.limit_lower')"
              >
                <template slot-scope="props">
                  {{ props.row.operator_lim_inf }} {{ props.row.lim_inf }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="100"
                prop="operator_lim_sup"
                :label="$t('common_words.limit_upper')"
              >
                <template slot-scope="props">
                  <span v-if="parseFloat(props.row.lim_sup) > 0">
                    {{ props.row.operator_lim_sup }} {{ props.row.lim_sup }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                min-width="100"
                prop="recommendation"
                :label="$t('common_words.recommendation')"
              ></el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="
                exportToPDF({
                  route: 'grounds/ranges/pdf/' + rangeGroundForm.id,
                  name_file: 'rango_suelos.pdf',
                })
              "
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="
                exportToExcel({
                  route: 'grounds/ranges/excel/' + rangeGroundForm.id,
                  name_file: 'rango_suelos.xlsx',
                })
              "
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import mixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import configTable from './rangeTable';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      rangeGroundForm: {
        businesses_id: [],
      },
      pagination: {},
      tableColumns: [],
      tableViewData: null,
      viewDetails: false,
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    mixinDatePicker,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleView(index, row) {
      this.showHideLoading(true);

      this.tableViewData = row.range_details;
      this.rangeGroundForm = Object.assign({}, row);
      this.viewDetails = true;
      this.showHideLoading();

      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 100);
    },

    handleEdit(index, row) {
      this.rangeGroundForm = Object.assign({}, row);

      if (row.zone_id == null) {
        this.rangeGroundForm.zone_id = 0;
      }

      if (row.subzone_id == null) {
        this.rangeGroundForm.subzone_id = 0;
      }

      if (row.crop_variety_id == null) {
        this.rangeGroundForm.crop_variety_id = 0;
      }

      row.url_path_form = '/grounds/ranges/edit';
      sessionStorage.setItem('editForm', JSON.stringify(this.rangeGroundForm));
      this.$router.push({ path: '/grounds/ranges/edit' });
    },

    handleDelete(index, row) {
      this.rangeGroundForm = row;
      SweetAlert.delete(i18n.t('samples.the_range') + row.date).then(
        (result) => {
          if (result.value) this.deleteRange();
        }
      );
    },

    deleteRange() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.rangeGroundForm.route = 'grounds/ranges';
        Axios.destroyMaster(this.rangeGroundForm)
          .then((response) =>
            this.modifyTable(2, this.rangeGroundForm.id, response)
          )
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF(data) {
      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel(data) {
      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('grounds/ranges')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('grounds');
  },

  destroyed() {
    this.deselectedItemOnMenu('grounds');
  },
};
</script>
<style>
.width-label {
  width: 500px !important;
}
</style>
